import { render, staticRenderFns } from "./recordItem.vue?vue&type=template&id=0a04de27&scoped=true"
import script from "./recordItem.vue?vue&type=script&lang=js"
export * from "./recordItem.vue?vue&type=script&lang=js"
import style0 from "./recordItem.vue?vue&type=style&index=0&id=0a04de27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a04de27",
  null
  
)

export default component.exports